module.exports = __webpack_public_path__ + "static/img/150018.1f024630.png";